import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, tap } from 'rxjs';
import { DocumentPreviewApi } from '../../APIs/documents/document-preview.api';
import { DocumentEntity } from '../../entities/document.entity';
import { DomainTranslateService } from '../../utils/domain-translate.service';

@Injectable({
    providedIn: 'root',
})
export class DocumentPreviewController {
    // * [API]
    private _api = inject(DocumentPreviewApi);

    // * [Injects]
    private _router = inject(Router);
    private _i18n = inject(DomainTranslateService);

    /**
     * Busca o preview do documento
     * @param _id ID do documento
     * @returns DocumentEntity
     */
    public get(_id: string): Observable<DocumentEntity> {
        try {
            if (!_id) throw this._i18n.instant('domain.validation.documentIdRequired');

            return this._api.get(_id);
        } catch (error) {
            throw error;
        }
    }

    /**
     * Verifica se o preview do documento é privado
     * @param _id ID do documento
     * @returns Observable<boolean>
     */
    public checkDocumentAccess(_id: string): Observable<string> {
        try {
            if (!_id) throw this._i18n.instant('domain.validation.documentIdRequired');

            return this._api.checkDocumentAccess(_id).pipe(
                tap(response => {
                    if (response === 'NEED_LOGIN') {
                        this._router.navigate(['/auth/login']);
                        localStorage.setItem('private_document', 'true');
                        localStorage.setItem('url_to_redirect', this._router.url);

                        return response;
                    }
                })
            );
        } catch (error) {
            throw error;
        }
    }
}
